(function () {

    // === CONFIG ===
    const urlParams = new URLSearchParams(window.location.search);
    const debugFromURL = urlParams.get("gar_debug") === "true";

    const config = {
        debug: debugFromURL,
    };

    const log = (...args) => config.debug && console.log("🟢 shopify-forms-detector:", ...args);

    const LOG_PREFIX = "[ShopifyFormsDetector]";
    const seen = new WeakSet();
    const hookedForms = new WeakSet();
    const observedRoots = new WeakSet();

    function collectInvalidFields(form) {
        return [...form.querySelectorAll('[aria-invalid="true"]')];
    }

    function watchFormStatus(form, callback) {
        form.addEventListener("submit", (e) => {
            const immediateInvalid = collectInvalidFields(form);

            if (immediateInvalid.length > 0) {
                e.preventDefault();
                callback({
                    status: "failed",
                    invalidFields: immediateInvalid,
                });
                return;
            }

            setTimeout(() => {
                const delayedInvalid = collectInvalidFields(form);
                if (delayedInvalid.length > 0) {
                    callback({
                        status: "failed",
                        invalidFields: delayedInvalid,
                    });
                    return;
                }

                callback({
                    status: "passed",
                });
            }, 0);
        });
    }

    function isShopifyForm(el) {
        return el.tagName === "SHOPIFY-FORMS-EMBED" || el.hasAttribute("data-form-root");
    }

    function logForm(el) {
        if (seen.has(el)) return;
        seen.add(el);

        const meta = {
            id: el.id || null,
            hasShadowRoot: Boolean(el.shadowRoot),
            dataset: {
                formRoot: el.dataset?.formRoot || null,
                currentStep: el.dataset?.currentStep || null,
            },
        };

        log("Found Shopify form", meta);
        attachSubmitListeners(el);
    }

    function pushGtmEvent(payload) {
        const data = { event: "gift_form_submit", payload };

        // 2️⃣ Shopify analytics bridge → custom pixels (GTM, etc.)
        if (window.Shopify?.analytics?.publish) {
            Shopify.analytics.publish("gift_form_submit", data);
            log("Shopify.analytics.publish: gift_form_submit", data);
        } else {
            log("⚠️ Shopify.analytics.publish not available yet.");
        }

        log("Pushed GTM event", data);
    }

    function attachSubmitListeners(host) {
        const root = host.shadowRoot || host;
        const forms = root.querySelectorAll('form[data-testid="form"], form');

        forms.forEach((form) => {
            if (hookedForms.has(form)) return;
            hookedForms.add(form);

            watchFormStatus(form, (status) => {
                if (status.status !== "passed") {
                    log("Validation failed", {
                        invalidCount: status.invalidFields.length,
                    });
                    return;
                }

                {
                    const meta = {
                        id: host.id || null,
                        currentStep: host.dataset?.currentStep || null,
                        action: form.action || null,
                        method: form.method || "get",
                    };
                    log("Submit", meta);
                    pushGtmEvent(meta);
                }
            });
        });

        if (!observedRoots.has(root)) {
            observedRoots.add(root);
            const obs = new MutationObserver(() => attachSubmitListeners(host));
            obs.observe(root, { childList: true, subtree: true });
        }
    }

    function scan(node) {
        if (!(node instanceof Element)) return;
        if (isShopifyForm(node)) logForm(node);
        node.querySelectorAll("shopify-forms-embed, [data-form-root]").forEach(logForm);
    }

    function init() {
        scan(document);

        const observer = new MutationObserver((mutations) => {
            for (const { addedNodes } of mutations) {
                addedNodes.forEach(scan);
            }
        });

        observer.observe(document, { childList: true, subtree: true });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init, { once: true });
    } else {
        init();
    }
})();
